import { render, staticRenderFns } from "./StaleSaveNotice.vue?vue&type=template&id=7137f69b&scoped=true"
import script from "./StaleSaveNotice.vue?vue&type=script&lang=js"
export * from "./StaleSaveNotice.vue?vue&type=script&lang=js"
import style0 from "./StaleSaveNotice.vue?vue&type=style&index=0&id=7137f69b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7137f69b",
  null
  
)

export default component.exports